export default ({ request }) => ({
  mrpInspectionAqlListApi(data = {}) {
    return request({
      url: '/factory/mrp/inspection/aql/list',
      method: 'post',
      data,
    })
  },
  mrpInspectionAqlDetailApi(data = {}) {
    return request({
      url: '/factory/mrp/inspection/aql/detail',
      method: 'post',
      data,
    })
  },
  mrpInspectionAqlSaveApi(data = {}) {
    return request({
      url: '/factory/mrp/inspection/aql/save',
      method: 'post',
      data,
    })
  },
  mrpInspectionAqlDelApi(data = {}) {
    return request({
      url: '/factory/mrp/inspection/aql/del',
      method: 'post',
      data,
    })
  },
})
